import React from "react";
import { Link } from "react-router-dom";
import {
  Table,
  Download,
  PlusCircle,
  Target,
  Settings,
  Database,
  Network,
} from "lucide-react";

function GlobeDataTools() {
  return (
    <div className="mx-auto max-w-xl px-4 pt-4 text-center">
      <div className="flex flex-col items-start">
        <button
          onClick={() => window.history.back()}
          className="mr-4 mb-4 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
        >
          ← Back
        </button>
        <h1 className="mb-4 mt-0 text-4xl font-bold dark:text-white">
          Welcome to Globe Data Tools
        </h1>
      </div>
      <div className="mt-8 max-w-md mx-auto space-y-4">
        <Link
          to="/add-intervention-points"
          className="flex items-center gap-3 bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors duration-200"
        >
          <PlusCircle size={20} />
          <span>Add Intervention Points</span>
        </Link>

        <Link
          to="/match-intervention-points"
          className="flex items-center gap-3 bg-yellow-500 text-white px-6 py-3 rounded-lg hover:bg-yellow-600 transition-colors duration-200"
        >
          <Target size={20} />
          <span>Match Intervention Points</span>
        </Link>

        <Link
          to="/manage-sectors"
          className="flex items-center gap-3 bg-indigo-500 text-white px-6 py-3 rounded-lg hover:bg-indigo-600 transition-colors duration-200"
        >
          <Settings size={20} />
          <span>Manage Sectors</span>
        </Link>

        <Link
          to="/targets-and-qualification"
          className="flex items-center gap-3 bg-teal-500 text-white px-6 py-3 rounded-lg hover:bg-teal-600 transition-colors duration-200"
        >
          <Database size={20} />
          <span>Targets and Qualifications</span>
        </Link>
      </div>
    </div>
  );
}

export default GlobeDataTools;
